export default __webpack_public_path__ + "static/bg-d-abfb7cabc303a22ce6e97a1a9a9a57ef.jpg";